export default __webpack_public_path__ + "static/media/D042_tn.a8b051f9.jpg";